import {PixiSpineAnimation} from "./pixi-spine-animation";

export enum AnimatedIconUnloadReason {
    CONTEXT_LOST,
    VIEWPORT_EXIT,
    REQUESTED,
    GAME_OPEN
}

export interface IAnimatedIconRequestOptions {
    jsonUrl: string;
    wrapper: HTMLElement;
    size: {width: number; height: number};
    timings: {delay: number; interval: number;};
    animationName?: string;
    onAnimationLoad?(): void;
    onAnimationWillUnload?(reason: AnimatedIconUnloadReason): void;
}

export type AnimatedIconObservableTarget = IAnimatedIconRequestOptions & {
    animation?: PixiSpineAnimation;
    animationDisposer?(reason: AnimatedIconUnloadReason): void;
    inViewport?: boolean;
};
